import { put, select, takeEvery } from 'redux-saga/effects'

import { SET_PERMISSIONS, SET_TABS } from '@redux/actions/types'

const getRoutes = state => state.routes.routes

const getPermissions = state => ({
  hasResources: state.config.hasResources,
  hasTipping: state.config.hasTipping
})

/**
 * Updates tab visibility based on feature permissions (tipping, resources, engage).
 */
function * onSetPermissions() {
  const { hasResources, hasTipping } = yield select(getPermissions)

  const routes = yield select(getRoutes)

  const tabRoutes = routes.filter(({ tab }) => tab)

  const newTabs = tabRoutes.map(route => {
    const { tab } = route
    const { path } = tab

    switch (path) {
    case 'tips':
      return {
        ...route,
        tab: {
          ...tab,
          display: hasTipping
        }
      }
    case 'resources':
      return {
        ...route,
        tab: {
          ...tab,
          display: hasResources
        }
      }
    case 'engage':
      return {
        ...route,
        tab: {
          ...tab,
          display: false
        }
      }
    default:
      return { ...route }
    }
  })

  yield put({
    type: SET_TABS,
    payload: newTabs
  })
}

/**
 * Root saga that watches for route permission changes.
 */
function * watchRoutes() {
  yield takeEvery(SET_PERMISSIONS, onSetPermissions)
}

export default watchRoutes
